import { createSlice } from "@reduxjs/toolkit"
import Client from "shopify-buy"
import littledata from "@littledata/headless-shopify-sdk"

const ga4MeasurementId = "G-G08THS0RPD"

const client = Client.buildClient({
  domain: "checkout.tennents.co.uk",
  storefrontAccessToken: "59e087f1d1bb2315e7211f633ef1e0ca",
})

const app = createSlice({
  name: "cart",
  initialState: {
    checkout: null,
  },
  reducers: {
    setState: (state, action) => {
      return { ...state, ...action.payload }
    },
  },
})

export const initializeCheckout = () => async dispatch => {
  const isBrowser = typeof window !== "undefined"

  const existingCheckoutID = isBrowser
    ? localStorage.getItem("shopify_checkout_id")
    : null

  if (!existingCheckoutID) {
    createCart(dispatch)
  } else {
    try {
      const currentCheckout = await client.checkout.fetch(existingCheckoutID)
      const littledataNoteAttributes = await littledata.fetchClientIds({
        ga4MeasurementId,
      })
      const input = { customAttributes: littledataNoteAttributes }

      client.checkout.updateAttributes(existingCheckoutID, input)
      if (currentCheckout.completedAt) {
        createCart(dispatch)
      }

      dispatch(
        setState({
          checkout: currentCheckout,
        }),
      )
    } catch (e) {
      createCart(dispatch)
    }
  }
}

const createCart = async dispatch => {
  const newCheckout = await client.checkout.create()
  const littledataNoteAttributes = await littledata.fetchClientIds({
    ga4MeasurementId,
  })
  const input = { customAttributes: littledataNoteAttributes }

  client.checkout.updateAttributes(newCheckout.id, input)

  localStorage.setItem("shopify_checkout_id", newCheckout.id)
  dispatch(
    setState({
      checkout: newCheckout,
    }),
  )
}

export const addToCart =
  ({ checkoutId, product }) =>
  async dispatch => {
    const cart = await client.checkout.addLineItems(checkoutId, [
      {
        variantId: product.shopifyId,
        quantity: product.quantity,
        customAttributes: product.personalisation
          ? {
              key: "Personalisation",
              value: product.personalisation,
            }
          : null,
      },
    ])
    dispatch(
      setState({
        checkout: cart,
      }),
    )
  }

export const updateLineItem =
  (checkoutID, lineItemID, quantity) => async dispatch => {
    const lineItemsToUpdate = [
      { id: lineItemID, quantity: parseInt(quantity, 10) },
    ]

    const updatedCart = await client.checkout
      .updateLineItems(checkoutID, lineItemsToUpdate)
      .then()

    dispatch(
      setState({
        checkout: updatedCart,
      }),
    )
  }

export const addGiftMessage =
  (checkoutId: string, note: string) => async dispatch => {
    const cart = await client.checkout
      .updateAttributes(checkoutId, { note })
      .then()

    dispatch(
      setState({
        checkout: cart,
      }),
    )
  }

export const { setState } = app.actions

export default app
